import AdminIndex from '../components/Admin/Index'
import AdminLog from '../components/Admin/Log'

export default [
  {
    path: '/admin',
    name: 'adminIndex',
    component: AdminIndex,
  },
  {
    path: '/admin/logs',
    name: 'adminLog',
    component: AdminLog,
  },
]
